module.exports = __webpack_public_path__ + "static/media/035.edf4cb67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/035.jpg
// module id = 331
// module chunks = 0